import { render, staticRenderFns } from "./SearchWeightCategoryForm.vue?vue&type=template&id=916f134c&scoped=true&"
import script from "./SearchWeightCategoryForm.vue?vue&type=script&lang=js&"
export * from "./SearchWeightCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./SearchWeightCategoryForm.vue?vue&type=style&index=0&id=916f134c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916f134c",
  null
  
)

export default component.exports